import React from "react";
import RestaurantList from "./List";
import RestaurantListLocationSorting from "./LocSortingHeader";

const ListContainer = () => (
    <React.Fragment>
        <RestaurantListLocationSorting />
        <RestaurantList />
    </React.Fragment>
);

export default ListContainer;
